export default {
  'component.delBtn.title': '确定删除吗？',
  'component.delBtn.tooltip': '删除',

  // 搜索表单公共文案
  'component.searchKeyword': '关键字',

  // 日期范围快捷选项(getDateRangePresets 消费,键名与 user-admin 用法同构)
  'component.dateRangePresets.today': '本日',
  'component.dateRangePresets.yesterday': '昨天',
  'component.dateRangePresets.thisWeek': '本周',
  'component.dateRangePresets.thisMonth': '本月',
  'component.dateRangePresets.last7Days': '前7天',
  'component.dateRangePresets.last30Days': '前30天',

  // 请求层框架文案(2026-09-28 收进内置 locales,键名与 user-admin 对齐;
  // 此前 requestErrorConfig.ts 硬编码中文,en 用户在框架错误面收中文)
  'request.error.loginExpiredTitle': '登录已失效',
  'request.error.loginExpiredContent': '您的登录已失效，请重新登录',
  'request.error.loginExpiredOkText': '确定',
  'request.error.loginExpiringTitle': '登录即将过期',
  'request.error.loginExpiringContent':
    '您的登录将在 {minutes} 分钟后过期，请及时保存数据',
  'request.error.requestFailed': '请求失败',
  'request.error.loginFailed': '登录失败，请检查账号或密码',
  'request.error.statusCode': '请求失败，状态码：{status}',
  'request.error.networkError': '网络请求失败，请检查网络连接',
  'request.error.unknownError': '请求错误，请重试',
};
